'use client';

import { TrackedButton, capsuleButtonVariants } from '@/components/button';
import { TRACKED_EVENT_POSITION } from '@/constants';
import { useInquiryChat } from '@/components/channel-talk';
import { cn } from '@lib/utils';

// 클릭 이벤트 label. 섹션_액션 패턴을 따른다.
const SERVICE_CTA_LABEL = 'service-cta_consult';

export function ServiceInquiryCta({ label }: { label: string }) {
  const inquiryChatProps = useInquiryChat();

  return (
    <div className="flex min-h-[42px] w-fit items-center md:min-h-[66px]">
      <TrackedButton
        label={SERVICE_CTA_LABEL}
        position={TRACKED_EVENT_POSITION.MAIN_CTA}
        {...inquiryChatProps}
        className={cn(
          capsuleButtonVariants({ variant: 'secondary', size: 'large' }),
          // 크기는 상단 Hero CTA와 동일하게 맞춤(색상은 secondary 유지)
          'px-5 py-2.5 text-[14px] font-semibold leading-4 tracking-[-0.128px] md:px-[32px] md:py-[16px] md:text-[22px] md:leading-[30.036px] md:tracking-normal',
          // hover 시 빨강. 시안 #FF1D1D 는 14px 흰 글씨에서 3.86:1 로 AA 미달이라 #CC0014(5.87:1)로 낮췄다.
          // focus:bg 는 메신저 닫은 뒤 색 잔상 방지용.
          // focus+hover 가 겹칠 땐 focus:hover 결합 변형이 더 높은 specificity(:focus:hover)로
          // hover 색을 우선시킨다 — !important 없이 해결.
          'hover:bg-3b-red-light-700 hover:text-white focus:bg-[#F0F2F5] focus:hover:bg-3b-red-light-700',
        )}
      >
        {label}
      </TrackedButton>
    </div>
  );
}
